import { AppRoutes } from './routes';
import AppProvider from './providers/app';
import { Provider } from 'react-redux';
import { store } from './store';
import AuthListener from './components/Auth/AuthListener';
import { LoadScript } from '@react-google-maps/api';
import { Result, Spin } from 'antd';
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from './lib/applicationInsights';

const ErrorFallback = () => (
  <Result
    status="500"
    title="Something went wrong"
    subTitle="The error has been reported. Please refresh and try again."
  />
);

function App() {
  return (
    <LoadScript
      googleMapsApiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}
      libraries={['places']}
      loadingElement={
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
          }}
        >
          <Spin size="large" />
        </div>
      }
    >
      <AppProvider>
        <Provider store={store}>
          <AuthListener />
          <AppInsightsErrorBoundary
            appInsights={reactPlugin}
            onError={ErrorFallback}
          >
            <AppRoutes />
          </AppInsightsErrorBoundary>

          {/* <Loader /> */}
        </Provider>
      </AppProvider>
    </LoadScript>
  );
}

export default App;
